// Booking module (templates/_blocks/_contentMatrix/_bookingBlock.twig, ADR 0027). The page is static (Blitz), so hours,
// closed dates, full slots and the CSRF token come from /actions/site/booking/availability. A slot is reserved in Craft
// first (capacity), then the form posts natively to the Pardot form handler, which sends the emails and redirects.
(function() {
    var MONTHS = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
    var DAYS = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];
    var TYPE_LABELS = { 'in-person': 'In-Person', virtual: 'Virtual' };
    var ICONS = {
        clock: '<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="12" cy="12" r="9"/><path d="M12 7v5l3 2"/></svg>',
        'in-person': '<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="12" cy="8" r="4"/><path d="M4 21c0-4 3.6-7 8-7s8 3 8 7"/></svg>',
        virtual: '<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="2.5" y="6" width="13" height="12" rx="2"/><path d="M15.5 10.5 21.5 7v10l-6-3.5"/></svg>',
    };
    var MESSAGES = {
        taken: 'Sorry, that time was just booked. Please choose another.',
        invalid: 'That time can’t be booked. Please choose another.',
        limit: 'You have reached the booking limit. Please call us to schedule.',
    };

    function pad(n) { return (n < 10 ? '0' : '') + n; }
    function ymd(year, month, day) { return year + '-' + pad(month + 1) + '-' + pad(day); }
    // Dates are clinic-local strings; build Dates in UTC so the visitor's timezone never shifts the day.
    function parts(date) { var p = date.split('-'); return { y: +p[0], m: +p[1] - 1, d: +p[2] }; }
    function weekday(date) { var p = parts(date); return (new Date(Date.UTC(p.y, p.m, p.d)).getUTCDay() + 6) % 7; } // 0 = Monday
    function clock(minutes) {
        var h = Math.floor(minutes / 60);
        return ((h + 11) % 12 + 1) + ':' + pad(minutes % 60) + ' ' + (h < 12 ? 'AM' : 'PM');
    }
    function longDate(date) {
        var p = parts(date);
        return DAYS[weekday(date)] + ', ' + MONTHS[p.m] + ' ' + p.d + ', ' + p.y;
    }

    function init(form) {
        var config = null;
        var full = {};
        var view = null; // {y, m} month shown
        var chosen = { date: null, minutes: null };
        var calEl = form.querySelector('[data-booking-cal]');
        var timesEl = form.querySelector('[data-booking-times]');
        var fieldsEl = form.querySelector('[data-booking-fields]');
        var summaryEl = form.querySelector('[data-booking-summary]');
        var errorEl = form.querySelector('[data-booking-error]');
        var unavailable = form.parentNode.querySelector('[data-booking-unavailable]');
        var endpoint = form.getAttribute('data-endpoint');
        var reserveUrl = form.getAttribute('data-reserve');
        var csrf = null;
        var busy = false;

        function typeValue() { return form.querySelector('input[name="type"]:checked').value; }
        function setError(message) {
            errorEl.textContent = message || '';
            errorEl.hidden = !message;
        }

        function load() {
            return fetch(endpoint, { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
                .then(function(r) { if ( !r.ok ) throw new Error(r.status); return r.json(); })
                .then(function(data) {
                    config = data;
                    csrf = data.csrf;
                    full = {};
                    data.full.forEach(function(slot) { full[slot] = true; });
                });
        }

        function dayHours(date) {
            var h = config.hours[weekday(date) + 1];
            return h && h.open && h.first !== null && h.last !== null ? h : null;
        }
        function dayOpen(date) {
            return date >= config.firstDate && date <= config.lastDate && config.closed.indexOf(date) === -1 && !!dayHours(date);
        }

        function renderCalendar() {
            var first = new Date(Date.UTC(view.y, view.m, 1));
            var lead = (first.getUTCDay() + 6) % 7;
            var count = new Date(Date.UTC(view.y, view.m + 1, 0)).getUTCDate();
            var min = parts(config.firstDate);
            var max = parts(config.lastDate);
            var canPrev = view.y > min.y || (view.y === min.y && view.m > min.m);
            var canNext = view.y < max.y || (view.y === max.y && view.m < max.m);
            var html = '<div class="ds-booking__month"><button type="button" class="ds-booking__nav" data-nav="-1" aria-label="Previous month"' + (canPrev ? '' : ' disabled') + '>‹</button>'
                + '<strong>' + MONTHS[view.m] + ' ' + view.y + '</strong>'
                + '<button type="button" class="ds-booking__nav" data-nav="1" aria-label="Next month"' + (canNext ? '' : ' disabled') + '>›</button></div>'
                + '<div class="ds-booking__grid" role="grid">';
            DAYS.forEach(function(d) { html += '<span class="ds-booking__dow" aria-hidden="true">' + d.slice(0, 2) + '</span>'; });
            for ( var i = 0; i < lead; i++ ) html += '<span></span>';
            for ( var day = 1; day <= count; day++ ) {
                var date = ymd(view.y, view.m, day);
                var open = dayOpen(date);
                html += '<button type="button" class="ds-booking__day' + (date === chosen.date ? ' is-selected' : '') + '" data-date="' + date + '"'
                    + (open ? '' : ' disabled') + ' aria-label="' + longDate(date) + '"' + (date === chosen.date ? ' aria-pressed="true"' : '') + '>' + day + '</button>';
            }
            calEl.innerHTML = html + '</div>';
        }

        function renderTimes() {
            if ( !chosen.date ) {
                timesEl.innerHTML = '<div class="ds-booking__empty">'
                    + '<svg class="ds-booking__empty-icon" viewBox="0 0 64 64" width="72" height="72" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">'
                    + '<rect x="8" y="12" width="48" height="44" rx="6"/><path d="M8 24h48M20 6v10M44 6v10"/><circle cx="32" cy="40" r="9"/><path d="M32 35v5l3.5 2"/></svg>'
                    + '<strong>Pick a day to see times</strong>'
                    + '<span>Choose a highlighted date on the calendar. Open times appear here.</span></div>';
                return;
            }
            var h = dayHours(chosen.date);
            var columns = { Morning: [], Afternoon: [] };
            for ( var t = h.first; t <= h.last; t += config.step ) {
                var slot = chosen.date + ' ' + pad(Math.floor(t / 60)) + ':' + pad(t % 60);
                var isFull = !!full[slot];
                columns[t < 720 ? 'Morning' : 'Afternoon'].push('<button type="button" class="ds-booking__time' + (t === chosen.minutes ? ' is-selected' : '') + '" data-minutes="' + t + '"'
                    + (isFull ? ' disabled' : '') + '>' + clock(t) + (isFull ? ' <small>full</small>' : '') + '</button>');
            }
            var html = '<h3 class="ds-booking__when">' + longDate(chosen.date) + '</h3><div class="ds-booking__cols">';
            Object.keys(columns).forEach(function(name) {
                if ( columns[name].length ) html += '<div><div class="ds-booking__label">' + name + '</div>' + columns[name].join('') + '</div>';
            });
            timesEl.innerHTML = html + '</div>';
        }

        function renderSummary() {
            var ready = chosen.date && chosen.minutes !== null;
            fieldsEl.hidden = !ready;
            if (!ready) { summaryEl.innerHTML = ''; return; }
            var p = parts(chosen.date);
            var type = typeValue();
            // The date tile repeats the date for the eye only; the full date is in the text beside it.
            summaryEl.innerHTML = '<div class="ds-booking__req">'
                + '<span class="ds-booking__req-date" aria-hidden="true">'
                + '<span class="ds-booking__req-month">' + MONTHS[p.m].slice(0, 3) + '</span>'
                + '<span class="ds-booking__req-day">' + p.d + '</span>'
                + '<span class="ds-booking__req-weekday">' + DAYS[weekday(chosen.date)].slice(0, 3) + '</span>'
                + '</span>'
                + '<div class="ds-booking__req-body">'
                + '<span class="ds-booking__req-tag">Requested time</span>'
                + '<strong class="ds-booking__req-when">' + longDate(chosen.date) + '</strong>'
                + '<span class="ds-booking__req-chips">'
                + '<span class="ds-booking__req-chip">' + ICONS.clock + clock(chosen.minutes) + ' <small>Indianapolis time</small></span>'
                + '<span class="ds-booking__req-chip">' + ICONS[type] + TYPE_LABELS[type] + ' consultation</span>'
                + '</span></div></div>';
        }

        function reset() {
            chosen = { date: null, minutes: null };
            renderCalendar();
            renderTimes();
            renderSummary();
        }

        calEl.addEventListener('click', function(e) {
            var nav = e.target.closest('[data-nav]');
            if ( nav ) {
                var next = new Date(Date.UTC(view.y, view.m + +nav.getAttribute('data-nav'), 1));
                view = { y: next.getUTCFullYear(), m: next.getUTCMonth() };
                renderCalendar();
                return;
            }
            var day = e.target.closest('[data-date]');
            if ( day && !day.disabled ) {
                chosen = { date: day.getAttribute('data-date'), minutes: null };
                setError('');
                renderCalendar();
                renderTimes();
                renderSummary();
            }
        });
        timesEl.addEventListener('click', function(e) {
            var time = e.target.closest('[data-minutes]');
            if ( time && !time.disabled ) {
                chosen.minutes = +time.getAttribute('data-minutes');
                setError('');
                renderTimes();
                renderSummary();
                if ( window.matchMedia('(max-width: 800px)').matches ) fieldsEl.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
            }
        });
        form.querySelectorAll('input[name="type"]').forEach(function(radio) { radio.addEventListener('change', renderSummary); });

        function hidden(name, value) {
            var input = form.querySelector('input[type="hidden"][name="' + name + '"]');
            if ( !input ) {
                input = document.createElement('input');
                input.type = 'hidden';
                input.name = name;
                form.appendChild(input);
            }
            input.value = value;
        }

        form.addEventListener('submit', function(e) {
            if ( form.getAttribute('data-posting') ) return; // the native post to Pardot
            e.preventDefault();
            if ( busy || chosen.minutes === null ) return;
            setError('');
            var field = function(name) { return form.querySelector('[name="' + name + '"]'); };
            var missing = ['first_name', 'last_name', 'email', 'phone'].filter(function(n) { return !field(n).value.trim(); });
            var invalid = !field('email').checkValidity();
            if ( missing.length || invalid ) {
                (missing.length ? field(missing[0]) : field('email')).focus();
                setError(missing.length ? 'Please fill in your name, email and phone number.' : 'Please enter a valid email address.');
                return;
            }

            var slot = chosen.date + ' ' + pad(Math.floor(chosen.minutes / 60)) + ':' + pad(chosen.minutes % 60);
            var body = new URLSearchParams({
                slot: slot,
                type: typeValue(),
                name: field('first_name').value.trim() + ' ' + field('last_name').value.trim(),
                email: field('email').value.trim(),
                website: field('website').value,
            });
            var headers = { Accept: 'application/json', 'X-CSRF-Token': csrf.token };
            var button = form.querySelector('button[type="submit"]');
            busy = true;
            button.disabled = true;
            fetch(reserveUrl, { method: 'POST', body: body, headers: headers, credentials: 'same-origin' })
                .then(function(r) { return r.json().catch(function() { return {}; }).then(function(data) { return { status: r.status, data: data }; }); })
                .then(function(res) {
                    if ( res.data.ok ) {
                        post(slot);
                        return;
                    }
                    busy = false;
                    button.disabled = false;
                    setError(MESSAGES[res.data.error] || 'Something went wrong. Please try again or call us.');
                    if ( res.status === 409 || res.status === 422 ) {
                        load().then(function() { chosen.minutes = null; renderTimes(); renderSummary(); });
                    }
                })
                .catch(function() {
                    busy = false;
                    button.disabled = false;
                    setError('Something went wrong. Please try again or call us.');
                });
        });

        // Slot held: post the lead to the Pardot form handler (it sends the emails and redirects to /booking-ty/).
        function post(slot) {
            // The handler's existing external field names (Pardot form handler field mappings).
            hidden('Booking Tool Requested Consult Type', TYPE_LABELS[typeValue()]);
            hidden('Booking Tool Requested Consult Date Time', longDate(chosen.date) + ', ' + clock(chosen.minutes) + ' (Indianapolis time)');
            var attribution = window.wghi && window.wghi.attribution ? window.wghi.attribution.pardotFields() : {};
            Object.keys(attribution).forEach(function(name) { hidden(name, attribution[name]); });
            // Only the handler's fields go out.
            form.querySelectorAll('input[name="type"], input[name="website"]').forEach(function(input) { input.disabled = true; });
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({ event: 'booking_submit', consultationType: typeValue(), appointmentSlot: slot });
            form.setAttribute('data-posting', '1');
            form.submit();
        }

        load().then(function() {
            if ( !config.handlerUrl ) throw new Error('no handler');
            form.action = config.handlerUrl;
            var start = parts(config.firstDate);
            view = { y: start.y, m: start.m };
            form.hidden = false;
            reset();
        }).catch(function() {
            if ( unavailable ) unavailable.hidden = false;
        });
    }

    document.querySelectorAll('form[data-booking]').forEach(init);
})();
